export default __webpack_public_path__ + "static/media/templateImports.a90dfe8c.csv";